import companyToken from "Utils/companyToken";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

export const getFlipper = (flipperNames) => {
  if (!Array.isArray(flipperNames)) flipperNames = [flipperNames];
  return fetchWithCSRFToken("/flipper", {
    method: "POST",
    body: JSON.stringify({
      flipper_names: flipperNames,
      company_id_token: companyToken(),
    }),
  });
};
